<docs>
# Notification Banner

> NOTE: this docs defined at **docs** section inside NotiBanner.vue module

Notification Banner UI Set


<!-- STORY -->

### Example

>Error

```html
<mt-noti-banner type="error" title="Notification title" subTitle="Subtitle" actionLabel="Action" />
```

>Warning(default)

```html
<mt-noti-banner type="warning" title="Notification title" subTitle="Subtitle" actionLabel="Action" />
```

>Success

```html
<mt-noti-banner type="success" title="Notification title" subTitle="Subtitle" actionLabel="Action" />
```

>Infomation

```html
<mt-noti-banner type="info" title="Notification title" subTitle="Subtitle" actionLabel="Action" />
```

### Props

| Property    | Description            | Type    | Accepted Values              | Default     |
|-------------|------------------------|---------|------------------------------|-------------|
| title       | title                  | String  | —                            | —           |
| subTitle    | sub title              | String  | —                            | —           |
| actionLabel | label of action button | String  | —                            | —           |
| type        | type of banner         | String  | error/warning/success/info   | warning     |

### Events

| Name         | Description                       | Parameters |
|--------------|-----------------------------------|------------|
| action       | fire when action-button clicked. It isn't working when actionLabel property is undefined | —          |
| close        | fire when close-button clicked.  | —          |

</docs>
<template>
  <div v-if="visibleBanner" class="mt-noti-banner" :class="'mt-noti-banner--'+type">
    <mt-icon :iconName="iconName" :hover="'not-set'" :color="iconColor" />
    <span class="title mt-font--body10">{{titlePrefix}}: {{title}}</span>
    <span class="sub-title mt-font--body10">{{subTitle}}</span>
    <span v-if="actionLabel" class="action mt-font--body10" @click="handleActionClick">{{actionLabel}}</span>
    <mt-icon class="close" iconName="close"  @click="handleClickClose"/>
  </div>
</template>

<script>
import MtIcon from '../icon/Icon.vue'
export default {
  name: 'mt-noti-banner',
  props: {
    title: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    actionLabel: {
      type: String,
    },
    type: {
      type: String,
      default: 'warning'
    }
  },
  components: {
    MtIcon
  },
  data () {
    return {
      colseIconColor: '',
      visibleBanner: true,
    }
  },
  computed: {
    titlePrefix() {
      if(this.type == 'error') return 'Error'
      if(this.type == 'warning') return 'Warning'
      if(this.type == 'success') return 'Success'
      if(this.type == 'info') return 'Information'
    },
    iconName() {
      if(this.type == 'error') return 'error-circle'
      if(this.type == 'warning') return 'warning-circle'
      if(this.type == 'success') return 'check-circle'
      if(this.type == 'info') return 'information-circle'
    },
    iconColor() {
      if(this.type == 'error') return '#f44336'
      if(this.type == 'warning') return '#FFC107'
      if(this.type == 'success') return '#00c853'
      if(this.type == 'info') return '#7364ff'
    }
  },

  methods: {
    handleClick(evt) {
      this.$emit('click', evt);
    },
    handleActionClick(evt) {
      this.$emit('action', evt);
    },
    handleClickClose() {
      this.visibleBanner = false
    }
  },


}
</script>
<style src="./NotiBanner.scss" lang="scss">
</style>



// WEBPACK FOOTER //
// NotiBanner.vue?559be4f5